import cx from 'classnames'
import { useContext, useMemo } from 'react'

import { ShopContext } from '@lib/shop-context'
import { formatPrice } from '@frame-builder/lib/format'

interface PriceBadgeProps {
  price: number
  disabled?: boolean
  showPlusSign?: boolean
  className?: string
}

const PriceBadge = ({
  price,
  disabled = false,
  showPlusSign = false,
  className,
}: PriceBadgeProps) => {
  const { currency, taxRate } = useContext(ShopContext)

  const priceString = useMemo(() => {
    const signString = showPlusSign && price > 0 ? '+' : ''

    const priceWithTax = price * (1 + taxRate)
    const formattedPrice = formatPrice(priceWithTax)
    const formattedPriceWithCurrency = [formattedPrice, currency]
      .filter(Boolean)
      .join(' ')

    return `${signString}${formattedPriceWithCurrency}`
  }, [currency, price, showPlusSign, taxRate])

  return (
    <div
      className={cx(
        'inline-block py-0.5 px-1.5 rounded-full text-xs text-black border border-black',
        {
          'line-through': disabled,
        },
        className,
      )}
    >
      {priceString}
    </div>
  )
}

export default PriceBadge
